import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesGeneralProductComponent} from "./general/sales-general-product.component";
import {SalesProductComponent} from "./sales-product.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";
import {GeneralModule} from "../general/general.module";



@NgModule({
  declarations: [
    SalesProductComponent,
    SalesGeneralProductComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    LibraryModule,
    GeneralModule
  ],
  exports: [
    SalesProductComponent,
    SalesGeneralProductComponent
  ]
})
export class SalesGeneralProductModule { }
